export default __webpack_public_path__ + "static/media/icon-nomix-info.0a9b06dc.svg";